import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController, Content, Events, ModalController } from 'ionic-angular';
import { Translate } from '../../providers/translate';
import { AuthData } from '../../providers/auth';
import { EventData } from '../../providers/event';
import { TranslateService } from '@ngx-translate/core';
import { EventProfilePage } from '../event-profile/event-profile';
import { UserRegisterPage } from '../user-register/user-register';
import { EventStands } from '../event-stands/event-stands';
import { VotePage } from "../vote/vote";
import { Observable } from "rxjs/Observable";
import { Database } from "../../providers/database";

@Component({
  selector: 'page-event',
  templateUrl: 'event.html'
})

export class EventPage {
  @ViewChild(Content) content: Content;

  // IV
  obsBadgeCatalog: any;
  tokenEvent: String;
  event: any;
  eventList: any;
  client: any;
  textTranslate: any;
  badgeUser: any = [];
  obs: any;
  obsActivity: any;
  obsListener: any;
  changeCount: any;
  dataActivity: any;
  componentState: any;
  timeLeft: any;
  //

  // TODO: Esto se debe pasar a la bbdd
  menuLabels = {
    notes: 'Notas',
    social: 'Redes sociales',
    speaker: 'Conferencistas',
    opinometer: 'Opinómetro',
    map: 'Mapa',
    diary: 'Agenda',
    networking: 'Networking',
    catalog: 'Catálogo',
    resource: 'Recursos',
    question: 'Preguntas',
    profile: 'Mi Perfil',
    stands: 'Muestra comercial'
  };

  /**
   *
   * @param navCtrl
   * @param auth
   * @param params
   * @param alertCtrl
   */
  constructor(public navCtrl: NavController, public params: NavParams, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public toastCtrl: ToastController, translate: Translate, public translateProvider: TranslateService, public auth: AuthData, public eventProvider: EventData, public events: Events, public modal: ModalController, public db: Database) {

    translate.translateGroup(["El módulo se encuentra inactivo en este momento", "Cargando", "Ok", "No se han encontrado opinómetros disponibles"]).then(data => {
      this.textTranslate = data;
    });

    this.event = this.params.get('event');
    this.eventList = this.params.get('eventList');
    this.client = this.params.get('client');

    this.event.configMenu.menuUnoIcon = this.getIcon(this.event.configMenu.menuUno);
    this.event.configMenu.menuDosIcon = this.getIcon(this.event.configMenu.menuDos);
    this.event.configMenu.menuTresIcon = this.getIcon(this.event.configMenu.menuTres);
    this.event.configMenu.menuCuatroIcon = this.getIcon(this.event.configMenu.menuCuatro);
    this.event.configMenu.menuCincoIcon = this.getIcon(this.event.configMenu.menuCinco);
    this.event.configMenu.menuSeisIcon = this.getIcon(this.event.configMenu.menuSeis);

    events.subscribe('client:login', () => {
      this.getBadgeUser();
    });

    // close de listener where logout user
    events.subscribe('client:logout', () => {
      this.closeListener();
    });

    // IV
    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'activity').subscribe(stateModule => {
      this.closeListener(true);

      if (stateModule.$value === true) {
        this.obsActivity = this.eventProvider.getActivity(this.client, this.event.id).subscribe((data) => {
          this.dataActivity = data;
          this.verifiedOpinometer();
          this.componentState = true;
        });
      } else {
        this.dataActivity = false;
        this.componentState = false;
        console.log("Módulo Activity deshabilitado");
      }
    });
    //
  }

  //IV
  verifiedOpinometer() {
    if (this.dataActivity.opinometerState && this.dataActivity.opinometers.length > 0) {
      let flag = false;

      this.dataActivity.opinometers.forEach((opinometer: any, key) => {
        this.db.getData('/Clients/' + this.client.url + '/Opinometers/' + opinometer)
        .then((result: any) => {
          if (result.val().isAlert) {
            if (!flag) {
              flag = true;
              this.db.getData('/Clients/' + this.client.url + '/___OpinometersUsers/' + result.val().id + '/' + this.auth.getUser().uid).then((result2: any) => {
                if (!result2.val()) {
                  let alert = this.alertCtrl.create({
                    title: this.event.title,
                    buttons: [{
                      text: this.textTranslate['Cancelar'],
                      handler: () => {}
                    },{
                      text: this.textTranslate['Abrir'],
                      handler: () => {
                        this.test();
                      }
                    }]
                  });

                  if (this.dataActivity.opinometers.length > 1) {
                    alert.setMessage(this.textTranslate['Se han activado nuevas encuestas'])
                  } else {
                    alert.setMessage(result.val().message[this.translateProvider.getDefaultLang()])
                  }

                  alert.present();
                }
              });
            }
          }
        });
      });
    }
  }

  test() {
    let opinometerData = [];
    let loading = this.loadingCtrl.create({
      content: this.textTranslate['Cargando']
    });
    loading.present();
    let alert = this.alertCtrl.create({
      title: this.textTranslate['Seleccione un opinómetro']
    });

    if (this.dataActivity.opinometerState && this.dataActivity.opinometers.length > 0) {
      this.obs = new Observable(observer => {
        this.dataActivity.opinometers.forEach((opinometer: any, key) => {
          this.db.getData('/Clients/' + this.client.url + '/Opinometers/' + opinometer)
          .then((result: any) => {
            observer.next(result.val());

            if (key == this.dataActivity.opinometers.length-1) {
              observer.complete();
            }
          });
        });
      });

      this.obs.subscribe(
        (result) => {
          opinometerData = result;

          alert.addInput({
            type: 'radio',
            label: result.title[this.translateProvider.getDefaultLang()],
            value: result
          });
        }, {},
        () => {
          alert.addButton(this.textTranslate['Cancelar']);
          alert.addButton({
            text: this.textTranslate['Ok'],
            handler: selected => {
              if (selected) {
                let modal = this.modal.create(VotePage, {event: this.event, client: this.client, opinometer: selected})
                modal.present();
              }
              loading.dismiss();
            }
          });
          if (this.dataActivity.opinometers.length > 1) {
            loading.dismiss().then(() => {
              alert.present();
            })
          } else {
            let modal = this.modal.create(VotePage, {event: this.event, client: this.client, opinometer: opinometerData})
            loading.dismiss();
            modal.present();
          }
        }
      );
    } else {
      let toast = this.toastCtrl.create({
        message: this.textTranslate['No se han encontrado opinómetros disponibles'],
        position: 'top',
        duration: 5000,
        showCloseButton: true,
        closeButtonText: this.textTranslate['Ok']
      });

      toast.present().then(() => {
        loading.dismiss();
      });
    }
  }
  //

  ionViewDidEnter() {
    this.goRegister(true);
    setTimeout(() => {
      this.goRegister();
    }, 60000);
  }

  goRegister(isUnique = false) {
    if (this.auth.getUser().isAnonymous && isUnique && !window.localStorage.getItem('clear-message-register')) {
      this.alertRegister();
      console.log(1)
    } else {
      if (this.auth.getUser().isAnonymous && !window.localStorage.getItem('clear-message-register')) {
        this.alertRegister();
        console.log(2)
      } else {
        if (window.localStorage.getItem('clear-message-register') && this.auth.getUser().isAnonymous) {
          let b = window.localStorage.getItem('clear-message-register').replace(/['"]+/g, '')
          if (((new Date().getTime() - parseInt(b)) / 60 / 1000) > 10) {
            this.alertRegister();
            console.log(3)
          }
        }
      }
    }
  }

  alertRegister() {
    this.alertCtrl.create({
      title: this.event.title,
      message: '¡Recuerda que debes registrarte para poder acceder a todos los módulos del sistema!',
      buttons: [
        {
          text: 'Ahora no',
          role: 'cancel',
          handler: () => {
            window.localStorage.setItem('clear-message-register', '"' + new Date().getTime() + '"');
            return true;
          }
        },
        {
          text: 'Registrarme',
          handler: () => {
            window.localStorage.setItem('clear-message-register', '"' + new Date().getTime() + '"');
            this.navCtrl.push(UserRegisterPage, { origin: 'register', client: this.client, event: this.event });
            // this.go('profile');
          },
        }
      ]
    }).present();
  }

  go(page) {
    let toast = this.toastCtrl.create({
      duration: 5000,
      position: 'top',
      closeButtonText: this.textTranslate['Ok'],
      showCloseButton: true
    });

    switch (page) {
      case 'diary':
      case 'social':
      case 'map':
      case 'networking':
      case 'speaker':
      case 'catalog':
        this.scrollToElement(page);
        break;
      case 'resource':
        // TODO: terminar
        break;
      case 'profile':
        this.viewProfile();
        break;
      case 'register':
        this.navCtrl.push(UserRegisterPage, { origin: 'register', client: this.client, event: this.event });
        break;
      case 'notes':
        let btnNote = document.getElementById('noteNow');
        if (btnNote) {
          btnNote.click();
        } else {
          toast.setMessage(this.textTranslate['El módulo se encuentra inactivo en este momento']);
          toast.present();
        }
        break;
      case 'question':
        let btnQuestion = document.getElementById('questionNow');
        if (btnQuestion) {
          btnQuestion.click();
        } else {
          toast.setMessage(this.textTranslate['El módulo se encuentra inactivo en este momento']);
          toast.present();
        }
        break;
      case 'opinometer':
        let btnOpinometer = document.getElementById('opinometerNow');
        if (btnOpinometer) {
          btnOpinometer.click();
        } else {
          toast.setMessage(this.textTranslate['No se han encontrado opinómetros disponibles']);
          toast.present();
        }
        break;
      case 'profile':
        this.viewProfile();
        break;
      case 'stands':
        if (this.event.modules.stands) {
          this.navCtrl.push(EventStands, { client: this.client, event: this.event });
        } else {
          toast.setMessage(this.textTranslate['El módulo se encuentra inactivo en este momento']);
          toast.present();
        }
        break;
    }
  }

  getIcon(page) {
    let icon: any;

    switch (page) {
      case 'diary':
        icon = 'md-calendar';
        break;
      case 'social':
        icon = 'ios-contacts';
        break;
      case 'speaker':
        icon = 'md-people';
        break;
      case 'map':
        icon = 'md-map';
        break;
      case 'networking':
        icon = 'md-people';
        break;
      case 'catalog':
        icon = 'md-pricetag';
        break;
      case 'notes':
        icon = 'md-create';
        break;
      case 'resource':
        icon = 'md-photos';
        break;
      case 'question':
        icon = 'md-help';
        break;
      case 'opinometer':
        icon = 'stats';
        break;
      case 'profile':
        icon = 'md-person';
        break;
      case 'stands':
        icon = 'md-pricetags';
        break;
    }

    return icon;
  }

  scrollToElement(id) {
    var el = document.getElementById(id);
    var rect = el.getBoundingClientRect();
    var posElement = (this.content.getContentDimensions().scrollTop + rect.top) - 50;
    this.content.scrollTo(0, posElement, 600);
    // TODO: bug if not module exist
  }

  viewProfile() {
    this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
  }

  getBadgeUser() {
    if (!this.auth.getUser().isAnonymous) {
      this.obsBadgeCatalog = this.eventProvider.getUser(this.client, this.auth.getUser().uid).subscribe((data: any) => {
        this.events.publish('catalog:badge', data.numCartPending);
        this.badgeUser = 0;

        if (data.numRequestNetworking) {
          // console.log(data.numRequestNetworking)
          this.badgeUser += data.numRequestNetworking;
        }

        if (data.numCartPending) {
          // console.log(data.numCartPending)
          this.badgeUser += data.numRequestNetworking;
        }
      });
    }
  }

  // IV
  closeListener(primaryListener = false) {
    if (this.obsBadgeCatalog) {
      console.log('Se eliminan los observables de Badge catalogs');
      this.obsBadgeCatalog.unsubscribe();
    }
  }
  //

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event/event.ts